module.exports = __webpack_public_path__ + "img/electronic_electric_use_selected.4f4b9ee0.svg";